import { render, staticRenderFns } from "./ClearingBill.vue?vue&type=template&id=3bc58880&scoped=true&"
import script from "./ClearingBill.vue?vue&type=script&lang=js&"
export * from "./ClearingBill.vue?vue&type=script&lang=js&"
import style0 from "./ClearingBill.vue?vue&type=style&index=0&id=3bc58880&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc58880",
  null
  
)

export default component.exports